import { render, staticRenderFns } from "./ShowMessageModal.vue?vue&type=template&id=084221a0&scoped=true&"
import script from "./ShowMessageModal.vue?vue&type=script&lang=js&"
export * from "./ShowMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084221a0",
  null
  
)

export default component.exports